import React from "react"
import { Box, Flex } from "rebass"
import { get } from "lodash"
import SelectField from "material-ui/SelectField"
import MenuItem from "material-ui/MenuItem"
import Toggle from "material-ui/Toggle"
import { Counter } from "../counter"
import { easeList } from "./BoxImageItem"
import { modeTexty, typeTexty } from "./utils"

const itemType = []
for (let i = 0; i < typeTexty.length; i++) {
  const item = typeTexty[i]
  itemType.push(<MenuItem value={item.id} key={i} primaryText={item.name} />)
}

const itemMode = []
for (let i = 0; i < modeTexty.length; i++) {
  const item = modeTexty[i]
  itemMode.push(<MenuItem value={item.id} key={i} primaryText={item.name} />)
}

const BoxTextAnimation = (props) => {
  const { data, onUpdateValue } = props
  const isAnimation = get(data, "isAnimation", false)
  const isEase = get(data, "isEase", false)
  const ease = get(data, "ease", "")
  const type = get(data, "type", "top")
  const mode = get(data, "mode", "smooth")
  const delay = get(data, "delay", 200)
  const duration = get(data, "duration", 1500)
  return (
    <Box w={[1]}>
      <Toggle
        label="Use Animation"
        style={{ width: 200 }}
        toggled={isAnimation}
        onToggle={(e) =>
          onUpdateValue("isAnimation", e.target.checked, props.index)
        }
      />
      {isAnimation && (
        <Box w={[1]}>
          <SelectField
            floatingLabelText="Type Animation"
            value={type}
            onChange={(event, index, value) =>
              onUpdateValue("type", value, props.index)
            }
            maxHeight={200}
          >
            {itemType}
          </SelectField>
          <SelectField
            floatingLabelText="Mode Animation"
            value={mode}
            onChange={(event, index, value) =>
              onUpdateValue("mode", value, props.index)
            }
            maxHeight={200}
          >
            {itemMode}
          </SelectField>
          <Flex
            w={[1]}
            direction={"row"}
            wrap={"wrap"}
            py={[1]}
            className="child-wrap"
          >
            <Counter
              isDisabled={false}
              title="Delay"
              onSetValue={(value) => onUpdateValue("delay", value, props.index)}
              value={delay}
              interval={1}
              subtitle=""
              minValue={0}
            />
            <Counter
              isDisabled={false}
              title="Duration"
              onSetValue={(value) =>
                onUpdateValue("duration", value, props.index)
              }
              value={duration}
              interval={1}
              subtitle=""
              minValue={100}
            />
          </Flex>
          <Toggle
            label="Use Ease"
            style={{ width: 200 }}
            toggled={isEase}
            onToggle={(e) =>
              onUpdateValue("isEase", e.target.checked, props.index)
            }
          />
          {isEase && (
            <Box w={[1]}>
              <SelectField
                floatingLabelText="Ease"
                value={ease}
                onChange={(event, index, value) =>
                  onUpdateValue("ease", value, props.index)
                }
                maxHeight={200}
              >
                {easeList}
              </SelectField>
            </Box>
          )}
        </Box>
      )}
    </Box>
  )
}
export default BoxTextAnimation



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/carouselanimation/BoxTextAnimation.js